import React, { useEffect } from 'react'
import { FormatDateTimeToSame } from '../../helpers/formatting'
import { selectAuth } from '../../redux/authSlice'
import { useSelector } from 'react-redux'

export default function LockNotice(props) {
  const { content,
    showUnlockButton,
    submitUnlock,
    saving,
    customerId,
    setLockCheck,
    setLockNotificationText,
    setLockAgentUserId,
    displayLockNotice,
    lockCheck,
    setDisplayLockNotice,
    requests } = props;

  const auth = useSelector(selectAuth)

  const checkLock = async (customerId) => {
    if (lockCheck) return
    try {
      requests.setEndpoint(
        `${process.env.REACT_APP_API_DOMAIN}/customer/${customerId}/check_lock`
      )
      const response = await requests.get()
      if (response.status === 200) {
        if (response.data) {
          setLockNotificationText('Locked by ' + response.data.lock_details.lock_agent_name + ', expiring at ' + FormatDateTimeToSame(response.data.lock_details.lock_expiration_date, 'MM/dd/yyyy hh:mm:ss a'))
          setLockAgentUserId(response.data.lock_details.lock_agent_user_id)
          setDisplayLockNotice(true)
        }
      }
    } catch (error) {
      //
    }
  }

  useEffect(() => {
    if (!auth.fromPageChange) { return }
    if (auth.accessToken) {
      checkLock(customerId)
      setLockCheck(true)
    }
  }, [auth])

  if (displayLockNotice) {
    return (
      <div className="columns is-full m-2 notification is-danger is-light p-0 is-align-items-center">
        {/* eslint-disable-next-line react/no-danger */}
        <div className="column is-half">
          <span dangerouslySetInnerHTML={{ __html: content }}></span>
        </div>
        {showUnlockButton && (
          <div className="column is-half has-text-right">
            <button className="button is-danger is-small ml-5 p-2" onClick={(e) => submitUnlock(0)} disabled={saving}>
              {saving ? 'Unlocking' : 'Unlock'}
            </button>
          </div>
        )}
      </div>
    )
  } else {
    return null
  }
}
